import { render, staticRenderFns } from "./ActionMealViewMeal.vue?vue&type=template&id=34f37130&scoped=true"
import script from "./ActionMealViewMeal.vue?vue&type=script&lang=js"
export * from "./ActionMealViewMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f37130",
  null
  
)

export default component.exports